import { Outlet } from "react-router-dom"
const MainInstallation = () =>{
    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}

export default MainInstallation;